import { ReactElement } from 'react'
import { Textarea } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { PropsDescriptionFieldTemplate } from './props'

const DescriptionFieldTemplate = ({
    setDescription,
    description,
}: PropsDescriptionFieldTemplate): ReactElement => {
    const { t } = useTranslation()

    return (
        <Textarea
            data-cy="DetailsDescriptionInput"
            minRows={2}
            onChange={(e) => setDescription(e.currentTarget.value)}
            placeholder={t('details.form.description.placeholder')}
            resize="none"
            rows={5}
            value={description}
        />
    )
}

export default DescriptionFieldTemplate
